import { z } from 'zod';
import { isoDateTime } from './common.js';
import { answerKindSchema, questionOptionSchema } from './domain.js';
/**
 * Scheduled prompts (core/domain/schedule.ts). Asserted against the core types
 * in tests/contract-types.test.ts. Limits mirror core's; the use-case checks
 * them again, together with the timezone, and answers 400 with every problem.
 */
export const SCHEDULE_NAME_MAX_CHARS = 80;
export const SCHEDULE_PROMPT_MAX_CHARS = 2000;
export const weekdaySchema = z.union([
    z.literal(0),
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
    z.literal(6),
]);
const at = { hour: z.number().int(), minute: z.number().int() };
export const scheduleRuleSchema = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('daily'), ...at }),
    z.object({ kind: z.literal('weekdays'), ...at }),
    z.object({ kind: z.literal('weekly'), days: z.array(weekdaySchema), ...at }),
    z.object({ kind: z.literal('monthly'), dayOfMonth: z.number().int(), ...at }),
]);
export const recipientsSchema = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('all') }),
    z.object({ kind: z.literal('users'), userIds: z.array(z.string()) }),
]);
export const deliveryChannelSchema = z.enum(['telegram', 'web']);
export const scheduleRunStatusSchema = z.enum(['ok', 'partial', 'failed', 'skipped']);
export const scheduleDraftSchema = z.object({
    name: z.string().max(SCHEDULE_NAME_MAX_CHARS),
    prompt: z.string().max(SCHEDULE_PROMPT_MAX_CHARS),
    scope: z.array(questionOptionSchema),
    rule: scheduleRuleSchema,
    timezone: z.string().max(64),
    recipients: recipientsSchema,
    channels: z.array(deliveryChannelSchema),
});
export const scheduledPromptSchema = scheduleDraftSchema.extend({
    id: z.string(),
    enabled: z.boolean(),
    owner: z.object({ id: z.string(), name: z.string() }),
    nextRunAt: isoDateTime,
    lastRunAt: isoDateTime.optional(),
    lastStatus: scheduleRunStatusSchema.optional(),
    createdAt: isoDateTime,
    updatedAt: isoDateTime,
});
export const scheduleRunSchema = z.object({
    id: z.string(),
    scheduleId: z.string(),
    startedAt: isoDateTime,
    finishedAt: isoDateTime,
    status: scheduleRunStatusSchema,
    outcome: answerKindSchema.optional(),
    delivered: z.number().int(),
    failed: z.number().int(),
    error: z.string().optional(),
});
//# sourceMappingURL=schedules.js.map